// extracted by mini-css-extract-plugin
module.exports = {"image":"Species_image__2wNGu","species":"Species_species__2GKXf","buttons":"Species_buttons__2FEEr","name":"Species_name__BG06b","sciName":"Species_sciName__MN0s8"};